import { Box, styled } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * Base style for the Accordion Box.
 */
const AccordionBoxBase = Object.assign(Object.assign({}, HelixStyles.fontBase), { borderRadius: '0.5rem', width: '100%' });
/**
 * Base style for the button used in the header.
 */
const AccordionButtonBase = {
    backgroundColor: 'transparent',
    border: 'none',
    alignItems: 'center',
    display: 'flex',
    width: '100%',
    '&:hover': { cursor: 'pointer' },
    '&:focus': { outline: 'none' },
    '&:focus-visible': {
        outline: HelixStyles.focusVisible4.outline,
        outlineOffset: '-2px',
    },
};
/**
 * Styled Box for a paged Accordion.
 */
export const AccordionBox = styled(Box)(() => (Object.assign(Object.assign({}, AccordionBoxBase), { backgroundColor: HelixPalette.white, height: 'fit-content' })));
/**
 * Styled Box for a paged Accordion.
 */
export const AccordionHeader = styled(Box)(() => ({
    backgroundColor: 'transparent',
    border: 'none',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
}));
/**
 * Styled button for a paged Accordion header.
 */
export const AccordionHeaderButton = styled('button')(() => (Object.assign(Object.assign({}, AccordionButtonBase), { flex: 1, overflow: 'hidden' })));
/**
 * Styled button for a paged Accordion expand/collapse button.
 */
export const AccordionHeaderExpandButton = styled('button')(() => (Object.assign(Object.assign({}, AccordionButtonBase), { borderRadius: '0.5rem', justifyContent: 'center', padding: '0.75rem' })));
